define('utils/ui-slider', [
    'jquery',
    'underscore',
    'velocity',
    'velocity.ui'
],  function ($, _, Velocity, VelocityUi) {
    'use strict';

    console.log('%cfile: ui-slider.js', 'color: #C2ECFF');

    var uiSlider = function uiSlider(){
        console.log('%ctrace: uiSlider', 'color: #ccc');

        var el = '[data-ui-slider]',
            section = '[data-ui-slider-section]',
            walker = '[data-ui-slider-walker]',
            duration = 300;

        var $el = $(el),
            $section;

        if($el.length <= 0){
            console.warn('%ctrace: uiSlider: not found dom elements', 'color: #ccc');
            return false;
        }

        $el.each(function(i, el){
            initialize($(el));
        });

        function initialize($el){
            var $elements = $el.find(section),
                props = {
                },
                hovered = 0;

            props.$walker = $el.find(walker);
            props.walkerWidth = props.$walker.width();
            props.walkerHeight = props.$walker.height();
            props.walkerTop = 8;
            props.elementsWidth = $elements.eq(0).width();
            props.elementsLength = $elements.length;

            if(props.elementsLength <= 0){
                return false;
            }

            props.$walker.css('top', $elements.filter('.active').position().top + props.walkerTop);
            props.$walker.css('left', $elements.filter('.active').position().left + props.elementsWidth / 2);

            $elements.off('mouseenter').on('mouseenter', function() {
                var $el = $(this),
                    $elements = $el.parents('[data-ui-slider]').find('[data-ui-slider-section]'),
                    index = $elements.index($el),
                    $prev = $elements.eq(index - 1),
                    $next = $elements.eq(index),
                    dir = '';

                if (index === 0) {
                    $prev = false;
                }

                if (hovered > index && $next && $next.length > 0) {
                    animate(props, $next, 'from-right');
                }

                if (hovered <= index && $prev && $prev.length > 0) {
                    animate(props, $prev, 'from-left');
                }

                console.log('hovered', hovered);
            });

            $elements.off('mouseleave').on('mouseleave', function() {
                var $el = $(this),
                    $elements = $el.parents('[data-ui-slider]').find('[data-ui-slider-section]'),
                    index = $elements.index($el);

                hovered = index;
            });
        }

        function animate (props, $el, dir) {
            var leftStart = $el.position().left + props.elementsWidth / 2 + props.walkerWidth,
                leftEnd = $el.position().left + props.elementsWidth + props.elementsWidth / 2 - props.walkerWidth;

            if (dir === 'from-right') {
                leftStart = $el.position().left + props.elementsWidth + props.elementsWidth / 2 - props.walkerWidth;
                leftEnd = $el.position().left + props.elementsWidth / 2 - props.walkerWidth / 2;
            }

            props.$walker.css('left', leftStart);

            props.$walker
                .velocity('stop', true)
                .velocity({'opacity': 1}, {
                    duration: 100,
                    queue: false
                })
                .velocity({
                    'left': leftEnd
                }, {
                    duration: 300,
                    delay: 0,
                    stagger: 0,
                    mobileHA: true,
                    begin: function(){
                    },
                    complete: function(){
                    }
                })
                .velocity({'width': props.walkerWidth * 3}, {
                    duration: 100,
                    queue: false,
                    complete: function () {
                    }
                })
                .velocity({'width': props.walkerWidth}, {
                    delay: 100,
                    duration: 100,
                    queue: false,
                    complete: function () {
                    }
                })
                .velocity({'opacity': 0}, {
                    delay: 200,
                    duration: 100,
                    queue: false,
                    complete: function () {
                    }
                });
        }
    };

    return uiSlider;
});

